// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"DeleteButton_deleteButton__B5f8b"};